import * as yup from "yup";

export const otpSchema = yup.object().shape({
  otp: yup
    .string()
    .required("OTP is required")
    .length(5, "OTP must be 5 digits")
    .matches(/^\d+$/, "OTP must contain only numbers"),
});
